import { useState } from "react";
import { Link } from "react-router-dom";
import LOGO from '../assets/logo_abs.png'

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
<header
  className="
    fixed top-0 left-0 w-full
    z-50
    bg-red-600 text-white
    shadow-md
  "
>
  <div className="max-w-6xl mx-auto px-6 py-2 flex justify-between items-center">

    {/* Logo */}
    <nav className="font-bold leading-tight">
      <Link to="/" className="hover:opacity-80 transition">
        <span className="text-lg block">
          A.B.S. GmbH
        </span>
        <span className="text-xs font-normal text-white block">
          Gebäudesanierung & Renovierung
        </span>
      </Link>
    </nav>

    {/* Desktop Navigation */}
    <nav className="hidden md:flex space-x-6 text-sm">
      <Link to="/" className="hover:underline">Home</Link>
      <Link to="/services" className="hover:underline">Dienstleistungen</Link>
      <Link to="/about" className="hover:underline">Wir & Unsere Projekte</Link>
      <Link to="/contact" className="hover:underline">Kontakt</Link>
    </nav>

    {/* Burger Button */}
    <button
      className="md:hidden focus:outline-none"
      onClick={() => setMenuOpen(!menuOpen)}
      aria-label="Menü öffnen"
    >
      <div className="space-y-1">
        <span className="block w-6 h-0.5 bg-white"></span>
        <span className="block w-6 h-0.5 bg-white"></span>
        <span className="block w-6 h-0.5 bg-white"></span>
      </div>
    </button>
  </div>

  {/* Mobile Menu */}
  {menuOpen && (
    <nav className="md:hidden bg-red-700 px-6 py-4 space-y-4 text-sm">
      <Link onClick={() => setMenuOpen(false)} to="/" className="block">
        Home
      </Link>
      <Link onClick={() => setMenuOpen(false)} to="/services" className="block">
        Dienstleistungen
      </Link>
      <Link onClick={() => setMenuOpen(false)} to="/about" className="block">
        Wir & Unsere Projekte
      </Link>
      <Link onClick={() => setMenuOpen(false)} to="/contact" className="block">
        Kontakt
      </Link>
    </nav>
  )}
</header>

  );
};

export default Header;
